import { FC } from 'react';
import { DevEnvWrapper } from '@components/common/DevEnvWrapper';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { ResultItemQuestions } from './questions';
import { ResultItemProps } from './types';

export const ResultItem: FC<ResultItemProps> = ({ resultItem }) => {
  const intl = useIntl();
  const {
    productRangeKey,
    termAndTypeKey,
    ltvPercentKey,
    feeKey,
    repaymentsKey,
    initialRateKey,
    maxFinancingKey,
    reversionRateKey,
    typeValueKey,
  } = ResultItemQuestions;

  return (
    <div className={'border-fog relative my-5 w-full rounded-2xl border border-solid'}>
      <div className={'flex justify-between'}>
        <div className={'xs:py-6 xs:w-1/2 xs:pl-11 md:w-2/6 md:py-10'}>
          <div className={'text-main xs:mb-1 flex content-center'}>
            <p className={'font-satoshi-black m-0 text-lg'}>
              <FormattedMessage id={productRangeKey + resultItem.productRange} />
            </p>
          </div>
          <p className={'text-ash font-satoshi-medium m-0'}>
            <FormattedMessage
              id={termAndTypeKey}
              values={{
                years: resultItem.term,
                type: intl.formatMessage({ id: typeValueKey + resultItem.productType }),
              }}
            />
          </p>
          <p className={'text-ash font-satoshi-medium m-0'}>
            <FormattedMessage
              id={ltvPercentKey}
              values={{
                ltv: intl.formatNumber(resultItem.ltv, {
                  style: 'percent',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                }),
              }}
            />
          </p>
          <p className={'text-ash font-satoshi-medium m-0'}>
            <FormattedMessage
              id={feeKey}
              values={{
                fee: intl.formatNumber(resultItem.fee, {
                  style: 'currency',
                  currency: 'GBP',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }),
              }}
            />
          </p>
          <DevEnvWrapper>id: {resultItem.id}</DevEnvWrapper>
        </div>
        <div
          className={
            'xs:py-6 xs:grid-cols-1 xs:w-1/2 grid gap-y-5 pr-11 pl-5 md:w-4/6 md:grid-cols-3 md:grid-rows-2 md:py-10'
          }
        >
          <div>
            <p className={'text-ash font-satoshi-medium m-0 mb-0.5 text-base'}>
              <FormattedMessage id={repaymentsKey} />
            </p>
            <p className={'text-main font-satoshi-black m-0 text-lg'}>
              <FormattedNumber
                value={resultItem.repayments}
                style={'currency'}
                currency={'GBP'}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
            </p>
          </div>
          <div>
            <p className={'text-ash font-satoshi-medium m-0 mb-0.5 text-base'}>
              <FormattedMessage id={initialRateKey} />
            </p>
            <p className={'text-main font-satoshi-black m-0 text-lg'}>
              <FormattedNumber
                value={resultItem.initialRate}
                style={'percent'}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
            </p>
          </div>
          <div>
            <p className={'text-ash font-satoshi-medium m-0 mb-0.5 text-base'}>
              <FormattedMessage id={maxFinancingKey} />
            </p>
            <p className={'text-main font-satoshi-black m-0 text-lg'}>
              <FormattedNumber
                value={resultItem.requestedFinance}
                style={'currency'}
                currency={'GBP'}
                minimumFractionDigits={0}
                maximumFractionDigits={0}
              />
            </p>
          </div>
          <div>
            <p className={'text-ash font-satoshi-medium m-0 mb-0.5 text-base'}>
              <FormattedMessage id={reversionRateKey} />
            </p>
            <p className={'text-main font-satoshi-black m-0 text-lg'}>
              <FormattedNumber
                value={resultItem.reversionRate}
                style={'percent'}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
              />
            </p>
          </div>
        </div>
        <DevEnvWrapper>id: {resultItem.id}</DevEnvWrapper>
      </div>
    </div>
  );
};
